{
  "title": "Suivi des activités",
  "manageFiltersButton": "Gérer les filtres",
  "refreshButton": "Actualiser",
  "exportReportButton": "Exporter le rapport",
  "ariaLabel": "onglets d'activité",
  "tabs": {
    "weeklyActivity": "Activité hebdomadaire",
    "recentActivity": "Activité récente",
    "fboActivity": "Activité FBO"
  },
  "dialog": {
    "title": "Gérer les filtres d'activité"
  },
  "errors": {
    "loadFailed": "Échec du chargement des données d'activité"
  }
}
